import React from 'react';
import { Link } from 'react-router-dom';

const ProjectCard = ({ project }) => {
  return (
    <Link to={`/projects/${project.id}`} className="project-card">
      <img src={project.mainImage} alt={project.name} />
      <h2>{project.name}</h2>
    </Link>
  );


};

export default ProjectCard;